import { BaseEntity } from "yt-ng-framework";

export class FirmaObjekat extends BaseEntity{
    constructor(){
        super();
    }
    
    FirmaID: number=null;
    NazivObjekta: string = null;
    MestoID: number  = null;
    Gln: string  = null;

    Deserialize(input: any){
        super.Deserialize(input);

        this.ID = input.ID;
        this.NazivObjekta = input.NazivObjekta;
        this.MestoID = input.MestoID;
        this.Gln = input.Gln;
        return this;
    }
    
    Serialize(input: FirmaObjekat){
        return input;
    }
}